// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__qoNOe","info":"Note_info__2_gv0","note":"Note_note__2llUF","actions":"Note_actions__2sgb-"};